<div class="app flex-row align-items-center">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-6">
                <div class="clearfix text-center">
                    <h1 class="display-3">500</h1>
                    <h4 class="pt-3">Houston, we have a problem!</h4>
                    <p class="text-muted">The page you are looking for is temporarily having an error.</p>
                </div>
            </div>
        </div>
    </div>
</div>